import React , { Component } from 'react';
import {Link} from "react-router-dom";
import {RouteEnumFinal} from "../../Config/RouteEnum";
import ButtonSecondary from "../Elements/ButtonSecondary";


class LoginAlert extends Component {

    render() {
        return (
            <div className='container vh-75'>
                <div className='row h-100 align-items-center'>
                    <div className='col-12'>
                        <div className='pr-20 pl-20'>
                            <div className='d-flex justify-content-center'>
                                <div className='img-cnt-48'>
                                    <img src={"/assets/images/vectors/ic_lamp_line_black.svg"}/>
                                </div>
                            </div>
                            <div className='mobile-h4 cl-black text-center mt-12'>
                                ورود به حساب کاربری
                            </div>
                            <div className='mobile-subtitle-regular cl-subtitle text-center mt-20'>
                                برای استفاده از این بخش نیاز به ورود به حساب کاربری خود دارد , برای ورود روی دکمه درج شده در پایین این متن ضربه بزنید.
                            </div>
                            <div className='pr-20 pl-20 mt-28'>
                                <Link to={RouteEnumFinal.AUTH_LOGIN_PHONE} className='td-none d-block' >
                                    <ButtonSecondary text='ورود به حساب کاربری' />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default LoginAlert